









































import {Vue, Component, Prop} from "vue-property-decorator";
import { SelectableTag } from "@api/models/SelectableTag";
import TagList from "@share/common/tag-list/TagList.vue";
import DarkModalWindow from "@service/components/modal/DarkModal.vue";
import FilterSelect from "@common/table/components/filter/FilterSelect.vue";
import DatePickerRange from '@share/common/form/form-controls/date/date-picker-range/DatePickerRange.vue';
import DatePickerInput from '@share/common/form/form-controls/date/date-picker/DatePickerInput.vue';
import FormGroup from "@share/common/form/form-group/FormGroup.vue";
import {FilterSetting} from "@common/table/interfaces/FilterSetting";
import {FilterSettingTagsData} from "@common/table/interfaces/FilterSettingTagsData";
import {FilterType} from "@common/table/enums/FilterTypes";

@Component({
    name: 'FilterModal',
    components: { TagList, DarkModalWindow, FilterSelect, DatePickerRange, DatePickerInput, FormGroup }
})
export default class FilterModal extends Vue {
    @Prop({ default: [] }) filters: FilterSetting[];

    isValid = true;

    applyFilters() {
        this.$emit('apply')
    }

    resetFilters() {
        this.filters.map((filterItem: FilterSetting) => {
            if (['dateRange', 'select'].includes(filterItem.type)  && filterItem.selectedItem) {
                filterItem.selectedItem = {};
            }
            if (filterItem.type === FilterType.tags && filterItem.tags) {
                filterItem.tags.map((item: FilterSettingTagsData) => {
                    item.isSelected = false;
                });
            }
            if (filterItem.type === FilterType.text) {
                filterItem.value = '';
            }
        });
        this.$emit('reset');
    }

    accumulateTag(eventItem: SelectableTag) {
        this.$emit('accumulate', eventItem);
    }

    getSelectValue(value: FilterSetting) {
        this.$emit('setSelectFilter', value);
    }

    changedDatePickerRange(value: { start?: string; end?: string }, filterName = '') {
        this.$emit('changedDatePickerRange', value, filterName);
    }

    setErrorsValidation(isValid: boolean) {
        this.isValid = isValid;
    }
}
